import {FlexProps} from "@FRAMEWORK/ui/types/d";
import styled from "styled-components";

const Flex = styled.div<FlexProps>`
	display: flex;
	align-items: ${props => props.align};
	flex-direction: ${props => (props.direction ? "column" : "row")};
	justify-content: ${props => props.justify};
	gap: ${props => (props.gap ? props.gap : "0")}px;
	width: ${props => props.width};
`;

export default Flex;
